import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Box, CircularProgress, IconButton, Paper } from '@mui/material';
import ReactHTMLParser from 'react-html-parser';
import CloseIcon from '@mui/icons-material/Close';

const Newsfeed = (props) => {

  const [ postACF, setPostACF ] = useState(null);
  const [ isVisible, setIsVisible ] = useState(true);
  const apiURL = process.env.NODE_ENV === "development" ? "http://localhost:10020/wp-json/wp/v2/posts" : window.location.protocol + "//" + window.location.host + "/wp-json/wp/v2/posts"

  useEffect(() => {
    const getNewsfeed = async () => {
      axios.get(apiURL, {
        params: {
          categories: "4",
          _fields: "acf",
          per_page: 1,
          status: "publish",

        },
      })
      .then(res => res.data)
      .then(data => {
        console.log(data);
        setPostACF(data[0].acf);
      })
      .catch(error => console.log(error))
      .finally(() => {})
    }
    getNewsfeed();

    return () => {};

  }, [apiURL])

  return (
    <>
      {
        isVisible ? (
          <Box>
            <Paper>
              <Box sx={{display: "flex", justifyContent: "flex-end"}}>
                <IconButton onClick={() => setIsVisible(!isVisible)} sx={{ position: "absolute", m:.25, zIndex: 9,}}>
                  <CloseIcon />
                </IconButton>
              </Box>
              { 
                postACF === null ? 
                  <Box sx={{alignItems: "center", display: "flex", justifyContent: "center",}}>
                    <CircularProgress sx={{m: 2,}} /> 
                  </Box> :
                  ( ReactHTMLParser(postACF.newsfeed) ) }
            </Paper>
          </Box>
        ) : null
      }
    </>
  )
}

export default Newsfeed